import { useMemo } from 'react'
import { Dropdown } from 'components/common'
import AggregatorDropdown from 'components/common/aggregatorDropdown'
import StoreDropdown from 'components/userManagement/storeDropdown'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { buildEnumOptions, FilterMeta } from 'utils/helpers'

type Props = {
  filterMeta?: FilterMeta
}

export const FILTER_FIELD_KDS_SYNC_LOG = 'kdsSyncFilters'

const KdsSyncLogFilterForm = ({ filterMeta }: Props) => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_KDS_SYNC_LOG)

  const statusOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'status', ['SUCCESS', 'FAILED']),
    [filterMeta],
  )

  const actionOptions = useMemo(
    () =>
      buildEnumOptions(filterMeta, 'action', [
        'CREATE',
        'UPDATE',
        'CANCEL',
        'WEBHOOK',
      ]),
    [filterMeta],
  )

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <div className="min-w-[200px]">
        <Dropdown
          name="status"
          label="Status"
          options={statusOptions}
          defaultValue={filters.status || ''}
          setValue={(_field: string, value: string) =>
            setField('status', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <Dropdown
          name="action"
          label="Action"
          options={actionOptions}
          defaultValue={filters.action || ''}
          setValue={(_field: string, value: string) =>
            setField('action', value)
          }
        />
      </div>

      <FilterTextInput
        label="Order No"
        value={filters.orderNo || ''}
        onApply={(value) => setField('orderNo', value)}
      />

      <div className="min-w-[200px]">
        <StoreDropdown
          withNoneOption
          name="storeCode"
          label="Store Code"
          defaultValue={filters.storeCode || ''}
          setValue={(_field: string, value: string) =>
            setField('storeCode', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <AggregatorDropdown
          withNoneOption
          name="aggregatorCode"
          label="Aggregator Code"
          defaultValue={filters.aggregatorCode || ''}
          setValue={(_field: string, value: string) =>
            setField('aggregatorCode', value)
          }
        />
      </div>

      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />

      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default KdsSyncLogFilterForm
